import React from "react";

const HomeVector = ({ fill }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7193 0.292789C10.5318 0.105316 10.2775 0 10.0123 0C9.74712 0 9.49282 0.105316 9.30529 0.292789L2.30529 7.29286L0.305288 9.29289C0.209778 9.38513 0.133596 9.49548 0.0811869 9.61749C0.0287779 9.73949 0.00119157 9.87071 3.77567e-05 10.0035C-0.00111606 10.1363 0.0241857 10.268 0.0744666 10.3909C0.124747 10.5137 0.199001 10.6254 0.292893 10.7193C0.386786 10.8132 0.498438 10.8874 0.621334 10.9377C0.744231 10.988 0.87591 11.0133 1.00869 11.0122C1.14147 11.011 1.27269 10.9834 1.39469 10.931C1.5167 10.8786 1.62704 10.8024 1.71929 10.7069L2.01229 10.4139V17C2.01229 17.7956 2.32836 18.5587 2.89097 19.1213C3.45358 19.6839 4.21664 20 5.01229 20H15.0123C15.8079 20 16.571 19.6839 17.1336 19.1213C17.6962 18.5587 18.0123 17.7956 18.0123 17V10.4139L18.3053 10.7069C18.4939 10.8891 18.7465 10.9899 19.0087 10.9876C19.2709 10.9853 19.5217 10.8801 19.7071 10.6947C19.8925 10.5093 19.9977 10.2585 20 9.99629C20.0022 9.73409 19.9014 9.48149 19.7193 9.29289L10.7193 0.292789Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default HomeVector;
